import { render } from "./payment-report-table.vue?vue&type=template&id=53891bfa"
import script from "./payment-report-table.vue?vue&type=script&lang=js"
export * from "./payment-report-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__